@if (displayEditor) {
  <kendo-window
    title="Help Editor"
    (close)="hideEditor()"
    [left]="250"
    [top]="150"
  >
    <div class="d-flex flex-column w-100 h-100">
      <kendo-stepper
        #stepper="kendoStepper"
        [steps]="steps"
        [currentStep]="currentStep"
        (currentStepChange)="goToStep($event)"
        [stepType]="'full'"
      ></kendo-stepper>
      @switch (currentStep) {
        @case (0) {
          <div class="pt-4">
            <div class="d-flex p-3 justify-content-center">
              <kendo-buttongroup [selection]="'single'">
                <button
                  kendoButton
                  [togglable]="true"
                  [selected]="editedDoc.type === helpTypeEnum.Tooltip"
                  (click)="editedDoc.type = helpTypeEnum.Tooltip; goToStep(1)"
                >
                  Tooltip
                </button>
                <button
                  kendoButton
                  [togglable]="true"
                  [selected]="editedDoc.type === helpTypeEnum.Walkthrough"
                  (click)="
                    editedDoc.type = helpTypeEnum.Walkthrough; goToStep(1)
                  "
                >
                  Walkthrough
                </button>
              </kendo-buttongroup>
            </div>
          </div>
        }
        @case (1) {
          <div class="pt-4">
            @if (editedDoc.type === helpTypeEnum.Walkthrough) {
              <help-editor-walkthrough
                #walkEditor
                [document]="editedDoc"
                (complete)="goToStep(2)"
              ></help-editor-walkthrough>
            }
            @if (editedDoc.type === helpTypeEnum.Tooltip) {
              <help-editor-tooltip
                #tooltipEditor
                [document]="editedDoc"
                (complete)="goToStep(2)"
              ></help-editor-tooltip>
            }
          </div>
        }
        @case (2) {
          <div class="p-4 m-4 d-flex align-items-center justify-content-center">
            @if (saveInProgress) {
              <i class="k-i-loading k-icon k-icon-xl"></i>
            }
            @if (!saveInProgress) {
              <div>
                @if (editedDoc.type === helpTypeEnum.Walkthrough) {
                  <div class="mb-3">
                    <label class="d-block mb-1">Start page</label>
                    <div class="d-flex align-items-center">
                      <input
                        kendoTextBox
                        type="text"
                        placeholder="/time-entry"
                        [formField]="settingsForm.route"
                      />
                      <button
                        kendoButton
                        type="button"
                        class="ms-2"
                        (click)="useCurrentPageAsRoute()"
                      >
                        Use current page
                      </button>
                    </div>
                    <small class="text-muted d-block mt-1">
                      The tour opens on this page before the first step. Leave
                      blank for a page-agnostic tour.
                    </small>
                  </div>
                }
                <label>
                  <input
                    type="checkbox"
                    kendoCheckBox
                    [formField]="settingsForm.isPublished"
                  />
                  <span class="ms-2">Published</span>
                </label>
                <div class="d-flex mt-4 mx-2">
                  @if (canDeleteHelpDocs && this.editedDoc.id !== null) {
                    <button
                      kendoButton
                      [icon]="'delete'"
                      (click)="deleteHelpDoc()"
                    >
                      Delete
                    </button>
                  }
                  <button
                    kendoButton
                    [primary]="true"
                    class="ms-2"
                    [icon]="'save'"
                    (click)="saveHelpDoc()"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            }
          </div>
        }
        @default {
          <div>output2</div>
        }
      }
    </div>
    <!-- <div class="d-flex"><button class="k-button ms-auto">Previous</button><button class="mx-2 k-button" [disabled]="currentStepIsInvalid()">Next</button></div> -->
  </kendo-window>
}
